<form [formGroup]="form" id="{{ baseId }}-modal-form" class="general-form" #modalForm="ngForm" (ngSubmit)="onSave()">
  <div class="emds">
    <div class="modal-default modal-flex">
      <div class="modal-header">
        <ng-container *ngIf="fcModalItemContext">
          <ng-container *ngIf="fcModalItemContext.mode === fcItemModalModeEnum.Modify">
          <span id="{{ baseId }}-header-title" translate>
            Modify {{ fcModalItemContext.findControlName }}
            <ng-container *ngIf="fcModalItemContext.selectedFindItemName">
              - {{ fcModalItemContext.selectedFindItemName }}
            </ng-container>
          </span>
          </ng-container>
          <ng-container *ngIf="fcModalItemContext.mode === fcItemModalModeEnum.New || fcModalItemContext.mode === fcItemModalModeEnum.NewRelItem">
            <span id="{{ baseId }}-header-title" translate>New {{ fcModalItemContext.findControlName }}</span>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="listItemName">
          <span id="{{ baseId }}-header-title" translate>{{ mode === fcItemModalModeEnum.New ? 'New' : 'Modify'}} {{ listItemName }}</span>
        </ng-container>
      </div>

      <div class="modal-body">
        <ng-container *ngIf="isLoading">
          <div class="text-center">
            <ap-spinner size="2"></ap-spinner>
          </div>
        </ng-container>

        <ng-container *ngIf="!isLoading">
          <ng-content></ng-content>
        </ng-container>
      </div>

      <div class="modal-footer">
        <button type="submit" id="{{ baseId }}-save-btn" class="btn btn-primary" [disabled]="(!form?.dirty || isSaving) && isSaveDisabled" translate>
          <ap-spinner *ngIf="isSaving; else notSaving" size="1"></ap-spinner>
          <ng-template #notSaving> Save </ng-template>
        </button>
        <button type="button" id="{{ baseId }}-cancel-btn" class="btn btn-secondary btn-flush-right" (click)="onCancel()" translate>
          Cancel
        </button>
      </div>
    </div>
  </div>
</form>
